import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';
import { noop } from 'lodash';
import { DataSource, generateAllCategory } from '../utils';
import * as Types from '../../types';
import type { FilterBulkDeleteResponseWithError } from '@src/api/filters';

export interface ManagementStoreProps {
  visible?: boolean;
  isFilterMetaLoading?: boolean;
  isFilterMetaError?: boolean;
  isSavedFiltersLoading?: boolean;
  isSavedFiltersError?: boolean;
  enableApplyAction?: boolean;
  filterEditor?: any;
  disabledDataSources?: DataSource[];
  dataSource: DataSource;
  filterMeta: Types.FilterMeta;
  onClose?: () => void;
  onDataSourceChange?: (dataSource: DataSource) => void;
  onFilterEditorReset?: () => void;
  onEditFilter?: (id: number, filter: Types.Filter, dataSource: DataSource) => any;
  onEnableFilter?: (id: number, dataSource: DataSource) => any;
  onDeleteFilter?: (
    ids: number[],
    dataSource: DataSource,
  ) => Promise<void | FilterBulkDeleteResponseWithError>;
  onCreateFilter?: (filter: Types.Filter, dataSource: DataSource) => any;
  onApplyNotify?: (id: number, filter: Types.Filter, dataSource: DataSource) => void;
  onFilterMetaRetry?: () => void;
  onSavedFiltersRetry?: () => void;
}

export const filterMeta = atom<Types.FilterMeta>({
  dimensions: [],
  categories: {},
});

export const dataSource = atom<DataSource>(DataSource.video);
export const currentCategory = atom(generateAllCategory());

export const callbacks = atom({
  onDataSourceChange: noop as ManagementStoreProps['onDataSourceChange'],
  onFilterEditorReset: noop as ManagementStoreProps['onFilterEditorReset'],
  onClose: noop as ManagementStoreProps['onClose'],
  onEditFilter: noop as ManagementStoreProps['onEditFilter'],
  onDeleteFilter: noop as ManagementStoreProps['onDeleteFilter'],
  onEnableFilter: noop as ManagementStoreProps['onEnableFilter'],
  onCreateFilter: noop as ManagementStoreProps['onCreateFilter'],
  onFilterMetaRetry: noop as ManagementStoreProps['onFilterMetaRetry'],
  onSavedFiltersRetry: noop as ManagementStoreProps['onSavedFiltersRetry'],
  onApplyNotify: noop as ManagementStoreProps['onApplyNotify'],
});

export const controlVariables = atom({
  enableApplyAction: false as ManagementStoreProps['enableApplyAction'],
  disabledDataSources: [] as ManagementStoreProps['disabledDataSources'],
});

// Temporary atoms
export const asyncLoadingMask = atom(false);
export const filterEditor = atomWithReset<null | {
  id: number;
  filter: Types.Filter;
  isPolicy?: boolean;
}>(null);
export const filterClone = atomWithReset<null | {
  id: number;
  filter: Types.Filter;
}>(null);
export const filterCreate = atomWithReset(false);
